import { merge } from 'lodash'

export default function (existingModel = {}) {
  return {
    model: merge(
      {
        name: null,
        email: null,
        mobileNumber: null,
        type: null,
        paddock: 'No',
        message: null
      },
      existingModel
    ),
    validation: {
      name: { required: true },
      mobileNumber: { required: true },
      email: { required: true, email: true },
      type: { required: true },
      message: { required: true }
    }
  }
}
